<div class="page-container image" *ngIf="imageSrc$ | async as imageSrc">
    <img [src]="imageSrc" />
</div>
